import { useFlags as useFlagsmith, IFlagsmithFeature } from 'flagsmith/react';

type FlagKeys = 'maintenance_mode';

export const useFlags = <T extends FlagKeys>(keys: T | T[]): Record<T, IFlagsmithFeature> => {
  const flags = useFlagsmith<string, string>(Array.isArray(keys) ? keys : [keys]);

  return flags as Record<T, IFlagsmithFeature>;
};
